import { Exclude, Type } from 'class-transformer';
import { ARCreditApplicationTransactionItemResultDto } from './ar-credit-application-transaction-item-result-dto';

export class ARCreditApplicationTargetTransactionResultDto {
    openBalance: number;
    appliedAmount: number;
    id: number;
    documentType: string;
    documentNumber: string;
    amount: number;
    @Type(() => Date)
    documentDate: Date;
    @Type(() => Date)
    postDate: Date;
    subLedgerTitle: string;
    subLedgerId: number;
    @Type(() => ARCreditApplicationTransactionItemResultDto)
    lineItems: ARCreditApplicationTransactionItemResultDto[];

    // transient variable
    @Exclude()
    isSelect: boolean;
    @Exclude()
    isAmountEditable: boolean;
    @Exclude()
    isSaved: boolean;
    @Exclude()
    lastSavedAppliedAmount: number;
}
